import { DeliveryOption } from "../../types/cart";
import { FeeSettingFree, ShippingFee } from "../../types/shipAddr";

export default function useIneligibleFreeShipOptionAmt(
  selectedShipOption: DeliveryOption | undefined,
  shippingFees: ShippingFee[] | undefined
) {
  if (!shippingFees || !selectedShipOption) return;
  if (selectedShipOption?.fee === 0) return;

  const freeOptionType = shippingFees.find((f) => f.shipOptionId === selectedShipOption.id && f.feeType === "free");
  return (freeOptionType?.feeOptionSetting as FeeSettingFree)?.freeAmtAbove;
}
